import { useState } from 'react';
import Breadcrumb from '@components/Shared/Breadcrumb';
import { Card, CardBody } from '@components/card/card';
import { useTranslation } from 'react-i18next';
import { Link, useNavigate } from 'react-router-dom';
import Loading from '@components/Shared/Loader/Loading';
import NeatixModal from '@components/Modal/NeatixModal';
import useGetInvAllocateList from '@hooks/INV/InvAllocate/useGetInvAllocateList';
import NtxTable from '@components/DataTable/NtxTable';
import ListPrint from '@components/Print/ListPrint';

const Index = () => {
  const Navigate = useNavigate();
  const { t, i18n } = useTranslation();
  const [transItem, setTransItem] = useState<any>();
  const [show, setShow] = useState(false);

  const { InvAllocateList: data, loading, error } = useGetInvAllocateList();
  // throw new Error("خطأ      ---   اسام خبيــر");

  // فلترة البيانات بناءً على البحث، ونوع الحركة

  const columns = [
    { title: t('Number'), key: 'num' },
    { title: t('Date'), key: 'date' },
    { title: t('TransType'), key: 'type' },
    { title: t(''), key: 'action', className: 'text-end', sortable: false }
  ];

  const tableData = data?.slice()?.map((item: any) => {
    // let rowClass;

    return {
      num: item.code,
      date: item.transactionDate?.split('T')[0],
      type: item.transactionTypeName,

      action: (
        <>
          <button
            type='button'
            className='btn btn-sm btn-outline-theme me-1'
            onClick={() => Navigate(`${item.id}/UpdateInvAllocate`)}
          >
            <i className='far fa-lg   fa-fw fa-edit'></i>
          </button>

          {/* زر الطباعة */}
          <button
            type='button'
            className='btn btn-sm btn-outline-secondary me-1'
            onClick={() => {
              setTransItem(item);
              setShow(true);
            }}
          >
            <i className='fas fa-lg fa-fw fa-print'></i>
          </button>

          {/* زر الحذف */}
          <button type='button' className='btn btn-sm btn-outline-danger me-1'>
            <i className='far fa-lg fa-fw fa-trash-alt'></i>
          </button>
        </>
      )
    };
  });

  //________________________________
  const BcrumbList = [
    {
      name: 'Home',
     link: ':moduleHome'
    },
    {
      name: 'حجــــز أصناف',
      link: null
    }
  ];

  return (
    <div>
      <div className='d-flex align-items-center'>
        <Breadcrumb BreadcrumbList={BcrumbList} PageName='حجــــز أصناف' />

        <div className='ms-auto'>
          <Link to='AddInvAllocate' className='btn me-1 btn-theme'>
            <i className='fa fa-plus-circle fa-fw me-1'></i>
            {t('حجـز جديــد')}
          </Link>{' '}
        </div>
      </div>

      <Card>
        <Loading loading={loading} error={error}>
          <CardBody>
            <NtxTable
              data={tableData || []}
              columns={columns}
              dataPerPage={10}
              theadClass=''
              tableClass='table text-nowrap table-hover '
              enableSearch
              showRecordsSelector
            />
          </CardBody>
        </Loading>
      </Card>

      <NeatixModal
        show={show}
        setShow={setShow}
        size='sm'
        showHeader={false}
        centered
        bodyClassName='p-0'
      >
        <Card>
          <CardBody>
            {transItem && (
              <>
                <div className='text-theme text-center bg-theme bg-opacity-10 fs-4 fw-bold mb-3'>
                  {transItem?.code}
                </div>
                <ListPrint
                  ReferenceId={transItem.id}
                  PrintTemplateTypeId='0324A2CD-561F-4E6E-8C38-F38E3C4FA56A'
                />
              </>
            )}
            <button
              type='button'
              className='btn btn-lg btn-default rounded-1 w-100 mt-3'
              onClick={() => setShow(false)}
            >
              <i className='fa fa-power-off fa-fw me-1'></i> {t('Cancel')}
            </button>
          </CardBody>
        </Card>
      </NeatixModal>
    </div>
  );
};

export default Index;
